
import { getElementHalfWidth } from '~/helpers/util'

export const DefaultPinBoxHeight = 30;
export const DefaultPinBoxWidth = 40;

export default {
  name: 'MoleculePin',
  components: {},
  props: {
    pinData: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false
    },
    onExpand: {
      type: Function,
      required: true,
      default: () => {}
    },
    onClose: {
      type: Function,
      required: true,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  computed: {
    pinStyle() {
      return {
        minWidth: `${DefaultPinBoxWidth}rem`,
        minHeight: `${DefaultPinBoxHeight}rem`
      };
    },
    engine3d() {
      return this.$engine3d || window.engine3d
    },
    clientManager() {
      return this.engine3d.default()
    },
    buildings() {
      return this.$store.state.project.project.buildings
    },
    selectedBuilding() {
      return this.$store.state.availability?.filters?.buildingId
    },
    buildingData() {
      return this.buildings.find((b) => b.id === this.selectedBuilding) || { code: 'main_view' }
    },
    isMenuOpen() {
      return this.$store.state.base.isAvailabilityMenuOpen
    }
  },
  mounted() {},
  methods: {
    openExpand() {
      if (!this.expanded && !this.pinData.no_content && !this.pinData.featured_link && !this.pinData.focus_point) {
        this.onExpand()
      }
      if (this.pinData.featured_link) {
        window.open(this.pinData.featured_link, '_blank')
      }
      if (this.pinData.focus_point) {
        const target = {
          x: this.pinData?.target_transform?.target?.x ?? this.pinData.location?.x ?? 0,
          y: this.pinData?.target_transform?.target?.y ?? this.pinData.location?.y ?? 0,
          z: this.pinData?.target_transform?.target?.z ?? this.pinData.location?.z ?? 0
        }
        const radius = this.pinData?.target_radius ?? 100
        const alpha = this.pinData?.target_transform?.alpha ?? 100
        const beta = this.pinData?.target_transform?.beta ?? 100

        const elementHalfWidth = getElementHalfWidth('#organism-sidebar-project')
        const offsetValueX = this.isMenuOpen && window.innerWidth > 900 ? -elementHalfWidth : 0
        const offsetValueY = window.innerWidth <= 900 ? -50 : 0
        const offsetTarget = { x: offsetValueX, y: offsetValueY }

        this.clientManager.focusToPoint(target, offsetTarget, radius, alpha, beta)

        // Set active focus point pin with only icon and title
        this.$store.dispatch('building/setActiveFocusPointPin', {
          icon: this.pinData.icon,
          title: this.pinData.title,
          category: this.pinData.category
        })
      }
    },
    closeExpand() {
      this.onClose()
    }
  }
}
